
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/terms/[slug]",
      function () {
        return require("private-next-pages/terms/[slug]/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/terms/[slug]"])
      });
    }
  